import { render, staticRenderFns } from "./Undelivered.vue?vue&type=template&id=3b2cc0c0"
import script from "./Undelivered.vue?vue&type=script&lang=js"
export * from "./Undelivered.vue?vue&type=script&lang=js"
import style0 from "./Undelivered.vue?vue&type=style&index=0&id=3b2cc0c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports